<template>
    <div ref="banner" class="topicBanner" :data-id="banner.id" :data-title="banner.title">
        <nuxt-link :to="urlBannerRedirect(banner.url)" class="topicBanner__images">
            <img :src="banner.image" :alt="banner.title" class="topicBanner__img" loading="lazy" />
        </nuxt-link>
        <div class="topicBanner__bottom">
            <div class="topicBanner__title">{{ banner.title }}</div>
            <div class="topicBanner__col2">
                <nuxt-link :to="urlBannerRedirect(banner.url)" class="btn btn-outline-primary topicBanner__btn">{{
                    banner.cta ? banner.cta : $t('topicBanner.cta')
                }}</nuxt-link>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import TopicBanner from '~/models/Banners/TopicBanner'

export default {
    props: {
        banner: {
            type: Object as PropType<TopicBanner>,
            required: true,
        },
    },

    methods: {
        urlBannerRedirect(url: string): string {
            if (url === '') {
                return ''
            }

            const urlObject = new URL(url)

            return `${urlObject.pathname}${urlObject.search}`
        },
    },
}
</script>

<style lang="scss" scoped>
.topicBanner {
    position: relative;
    box-shadow: $box-shadow;
    border-radius: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.topicBanner__images {
    width: 100%;
}

.topicBanner__img {
    min-height: 200px;
}

.topicBanner__bottom {
    padding: 18px 12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    background-color: $color-white;

    @media (min-width: $max-width-container-inside) {
        flex-direction: row;
    }
}

.topicBanner__title {
    font-weight: 590;
    font-size: 15px;
    align-content: center;
}

.topicBanner__text {
    font-size: 14px;
    line-height: 19px;
    margin: 11px 0 0 0;
}

.topicBanner__col2 {
    @media (min-width: $max-width-container-inside) {
        display: flex;
        align-items: center;
    }
}

.topicBanner__btn {
    padding: 5px 20px;
    min-width: 135px;
}
</style>
